/* eslint-disable @typescript-eslint/no-shadow */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable consistent-return */
import React, { FunctionComponent, useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useFormik } from 'formik';
import { useNavigate } from 'react-router-dom';
import {
  selectInterventionsChecklistValue,
  calculatorActions,
  selectInterventionsValue,
  selectServiceDataForm,
  selectState,
  selectTouched,
  selectReportName
} from '../../../../redux/calculatorSlice';
import {
  InterventionsChecklistForm,
  EarlyDetectionForm,
  IEarlyDetection,
  InterventionsCommonForm
} from '../../../../interfaces/interventions.interface';
import { CalculatorEnum } from '../../../../interfaces/calculator.interface';
import {
  InterventionHeader,
  InterventionBody,
  InterventionFooter,
  InterventionContainer,
  InterventionFieldNoteDialog
} from '../Intervention';
import { FormValidations, Constants, StringFormatter } from '../../../../utils';
import useDebounceEffect from '../../../../hooks/useDebounceEffect';
import { EarlyDetection as EarlyDetectionClass } from '../../../../calculations';
import { paths } from '../../..';
import { useLocation } from 'react-router';

const { DIALOG_MODES } = Constants,

 EarlyDetection: FunctionComponent = () => {

  const dispatch = useDispatch(),
   switchValue = useSelector(
    selectInterventionsChecklistValue(
      InterventionsChecklistForm.EarlyDetection
    )
  ),
   earlyDetectionData = useSelector(
    selectInterventionsValue(CalculatorEnum.EarlyDetection)
  ),

   serviceData = useSelector(selectServiceDataForm),
   selectedState = useSelector(selectState),
   touched = useSelector(selectTouched),
   reportName = useSelector(selectReportName),

   navigate = useNavigate(),
   location = useLocation(),

   [reinitialize, setReinitialize] = useState(true),
   [noteName, setNoteName] = useState<string>(''),
   [noteAction, setNoteAction] = useState<'add' | 'edit' | 'delete'>(DIALOG_MODES.ADD),
   [isNoteDialogOpen, setIsNoteDialogOpen] = useState(false),

   fields = [
    {
      text: `Number of children (ages 0-3) referred by HS for Head Start/Early Head Start/other educational preschool programs
      `,
      id: EarlyDetectionForm.NumberOfChildrenReferredToEarlyEducationPrograms,
      showError: true,
    },
  ],

   subInterventionfields = [
    {
      text: `Number of children (ages 0-3) identified through screening and/or surveillance (e.g., ASQ-3, ASQ-SE:2, SWYC) and referred by HS for Early Intervention services
      `,
      id: EarlyDetectionForm.NumberOfChildrenReferredToEarlyIntervention,
      showError: true,
    },
  ],

   onSubmit = (values: IEarlyDetection) => {

    if (touched) {

      dispatch(
        calculatorActions.saveReport({
          reportName,
          update: true,
          navigate:navigate,
          pathname:location.pathname
        }));

}
    navigate(
      StringFormatter.replaceWithReportName(
        reportName,
        paths.interventionsPositiveParenting
      )
    );

};

  useEffect(() => {

    if (switchValue) {

      const timeout = setTimeout(() => {

        setReinitialize(false);

}, 250);

      return () => {

        clearTimeout(timeout);

};

}

}, [switchValue]);

  const form = useFormik({
    initialValues: earlyDetectionData,
    validationSchema:
      switchValue &&
      FormValidations.intervention({
        [EarlyDetectionForm.NumberOfChildrenReferredToEarlyEducationPrograms]:
          FormValidations
            .required('')
            .test(FormValidations.getInterventionNumberOfChildsConfig(EarlyDetectionForm.NumberOfChildrenReferredToEarlyEducationPrograms, serviceData.csInput3)),
        [EarlyDetectionForm.NumberOfChildrenReferredToEarlyIntervention]:
            FormValidations
              .required('')
              .test(FormValidations.getInterventionNumberOfChildsConfig(EarlyDetectionForm.NumberOfChildrenReferredToEarlyIntervention, serviceData.csInput3)),
        [EarlyDetectionForm.PercentageOfChildrenReceivingEarlyInterventionServices]:
              FormValidations
                .required('')
                .test(FormValidations.getInterventionNumberOfChildsConfig(EarlyDetectionForm.PercentageOfChildrenReceivingEarlyInterventionServices, serviceData.csInput3)),
      }),
    onSubmit,
    validateOnBlur: false,
    validateOnChange: false,
    enableReinitialize: reinitialize || !switchValue,
  });

  useEffect(() => {

    if (!switchValue) {

      form.resetForm();
      dispatch(
        calculatorActions.clearInterventionData(CalculatorEnum.EarlyDetection)
      );

}

}, [switchValue]);

  useDebounceEffect(() => {

    const hasBeenEdited = Object.keys(form.values).some(
      (key) => !!form.values[key]
    );
    if (!form.dirty && !hasBeenEdited) return;
    /** Calculations happen */
    const earlyDetection = new EarlyDetectionClass({
      state: selectedState,
      serviceData,
      sliderEarlyDetectionLowEstimate: +form.values[
        InterventionsCommonForm.LowEstimate
      ],
      sliderEarlyDetectionHighEstimate: +form.values[
        InterventionsCommonForm.HighEstimate
      ],
      numberOfChildrenReferredToEarlyEducationPrograms: +form.values[EarlyDetectionForm.NumberOfChildrenReferredToEarlyEducationPrograms],
      numberOfChildrenReferredToEarlyIntervention: +form.values[EarlyDetectionForm.NumberOfChildrenReferredToEarlyIntervention],
      percentageOfChildrenReceivingEarlyInterventionServices: + form.values[EarlyDetectionForm.PercentageOfChildrenReceivingEarlyInterventionServices],

    }),

    // const savingsLow = earlyDetection.earlyDetectionEstimatedSavingsLow();
    // const savingsHigh = earlyDetection.earlyDetectionEstimatedSavingsHigh();

     longTermSavingsLow = earlyDetection.earlyDetectionEstimatedLow(),
     longTermSavingsHigh = earlyDetection.earlyDetectionEstimatedHigh();

    if (
      +form.values[InterventionsCommonForm.LongTermSavingsLow] !== longTermSavingsLow ||
      +form.values[InterventionsCommonForm.LongTermSavingsHigh] !== longTermSavingsHigh
    ) {

      form.setValues({
        ...form.values,
        [InterventionsCommonForm.LongTermSavingsLow]: longTermSavingsLow.toString(),
        [InterventionsCommonForm.LongTermSavingsHigh]: longTermSavingsHigh.toString(),
      });

}

    form.validateForm().then((errors) => {

      const isValid = !Object.keys(errors).length;

      if (form.dirty) {

        dispatch(
          calculatorActions.setInterventionData({
            intervention: CalculatorEnum.EarlyDetection,
            value: { ...form.values, isValid: !!isValid },
          })
        );
        dispatch(calculatorActions.setSummaryData());

}

});

}, [form.values]);

  const onSwitchChange = (e: React.ChangeEvent<HTMLInputElement>) => {

    dispatch(
      calculatorActions.toggleInterventionsChecklistValue({
        key: InterventionsChecklistForm.EarlyDetection,
        value: e.target.checked,
      })
    );

},

   onNote = (noteName: string, noteAction: 'add' | 'edit' | 'delete') => {

    setNoteName(noteName);
    setNoteAction(noteAction);
    setIsNoteDialogOpen(true);

},

   onDialogNoteClose = () => {

    setIsNoteDialogOpen(false);

};

  return (
    <>
      <InterventionContainer
        disabled={!switchValue}
        onSubmit={form.handleSubmit}
        header={
          <InterventionHeader
            title="Early Detection"
            checked={switchValue}
            onChange={onSwitchChange}
          />
        }
        body={
          <InterventionBody
            description={
              <>
                HS Specialists discuss ways to incorporate age-appropriate developmental activities into family routines and activities. They also make referrals to Early Head Start, Head Start and Early Intervention, and provide ongoing care coordination and systems navigation to ensure children are connected to necessary services. The following questions ask about the actions taken by caregivers in these situations during the 12-month date range.
              </>
            }
            header="Referrals to Early Education Programs"
            form={form}
            fields={fields}
            onNote={onNote}
          />
        }
        footer={
          <InterventionFooter
            form={form}
            savingsText="Early Detection"
            description="Percent of children referred for Head Start/Early Head Start/other educational preschool programs who enroll and attend"
            onNote={onNote}
            hideShortTerm={true}
            subInterventionSlider={true}
            subIntervention={
              <InterventionBody
                header="Referrals to Early Intervention (IDEA Part C)"
                form={form}
                fields={subInterventionfields}
                onNote={onNote}
              />
            }
          />
        }
      />
      <InterventionFieldNoteDialog
        id={`${noteName}__${noteAction}-dialog`}
        name={noteName}
        value={form.values[noteName]}
        mode={noteAction}
        open={isNoteDialogOpen}
        onClose={onDialogNoteClose}
        form={form}
      />
    </>
  );

};

export default EarlyDetection;
